import { defineMessages } from 'react-intl'

const scope = `modules.purchasing.components.poPDFLabelSetNameForm`

export default defineMessages({
  nameLabel: {
    id: `${scope}.nameLabel`,
    defaultMessage: 'PDF label name',
  },
  namePlaceholder: {
    id: `${scope}.namePlaceholder`,
    defaultMessage: 'New label set name',
  },
  nameRequiredError: {
    id: `${scope}.nameRequiredError`,
    defaultMessage: 'PDF label name is required',
  },
  cancelButton: {
    id: `${scope}.cancelButton`,
    defaultMessage: 'Cancel',
  },
})
